export default __webpack_public_path__ + "static/media/VL-MC3000BX-2.dbde2719.jpg";